import { render, staticRenderFns } from "./CameraDialogExam.vue?vue&type=template&id=6b744b7d&scoped=true"
import script from "./CameraDialogExam.vue?vue&type=script&lang=js"
export * from "./CameraDialogExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b744b7d",
  null
  
)

export default component.exports